<script>
import ItineraryPricesGroupPax from './ItineraryPricesGroupPax';

export default {
  name: 'ItineraryPricesPriceSettingsPax',
  props: {
    ageDiscounts: {
      type: Array,
      default: () => [],
    },
    groupPaxes: {
      type: Array,
      default: () => [],
    },
  },
  components: {
    ItineraryPricesGroupPax,
  },
  data() {
    return {
      priceSettingsIndividualPaxHeaders: [
        { text: '1', key: '1', width: '20' },
        { text: '2', key: '2', width: '20' },
        { text: '3', key: '3', width: '20' },
        { text: '4', key: '4', width: '20' },
        { text: '5', key: '5', width: '20' },
        { text: '6', key: '6', width: '20' },
        { text: '7', key: '7', width: '20' },
        { text: '8', key: '8', width: '20' },
        { text: '9', key: '9', width: '20' },
      ],
      priceSettingsGroupPaxHeaders: null,
      headers: [],
      individualPax: false,
      groupPax: false,
      radioGroup: 'individual',
      ageDiscountPaxes: null,
    };
  },
  created() {
    this.setHeaderPax();
  },
  watch: {
    priceSettingsGroupPaxHeaders: {
      handler() {
        this.setHeaderPax();
      },
    },
    groupPaxes: {
      deep: true,
      immediate: true,
      handler(value) {
        this.setGroupPax(value);
      },
    },
  },
  methods: {
    setHeaderPax() {
      if (this.radioGroup === 'individual') {
        this.$emit('update', this.priceSettingsIndividualPaxHeaders);
      } else if (this.radioGroup === 'group') {
        this.$emit('update', this.priceSettingsGroupPaxHeaders);
      }
    },
    setGroupPax(value) {
      this.priceSettingsGroupPaxHeaders = [...value];
    },
    setAgeDiscountPaxes(value) {
      this.ageDiscountPaxes = [...value];
      this.$emit('ageDiscount', this.ageDiscountPaxes);
    },
  },
};
</script>

<template>
  <div class="mt-2">
    <h3>Price settings</h3>
    <v-layout>
      <v-flex xs2>
        <v-radio-group v-model="radioGroup" row @change="setHeaderPax">
          <v-radio
            label="Individual"
            value="individual"
          />
          <v-radio
            :disabled="!priceSettingsGroupPaxHeaders.length"
            label="Group"
            value="group"
          />
        </v-radio-group>
      </v-flex>
      <v-flex xs1>
        <itinerary-prices-group-pax
          :group-paxes="groupPaxes"
          :title="'Create group pax'"
          @save="setGroupPax"
        />
      </v-flex>
      <v-flex xs1 class="ml-5">
        <itinerary-prices-group-pax
          :group-paxes="ageDiscounts"
          :title="'Create age discount paxes'"
          :button-color="'orange'"
          :row-name="'Age discount'"
          discounts
          single-digit
          @save="setAgeDiscountPaxes"
        />
      </v-flex>
    </v-layout>
  </div>
</template>



// WEBPACK FOOTER //
// src/components/itinerary/itineraryPrices/ItineraryPricesPriceSettingsPax.vue